import type {
  GetAllPostsByAppVariantAndSelectedGeoAreas1Request,
  PagedModelClientPost
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { InfiniteData } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { getPostProps } from '@/features/posts/utils/post';

export const useGetAllGroupPosts = (
  requestParameters: GetAllPostsByAppVariantAndSelectedGeoAreas1Request
) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  return useInfiniteQuery({
    queryKey: [
      API_CACHE_KEYS.GROUP_POSTS,
      requestParameters.groupId,
      requestParameters
    ],
    queryFn: ({ pageParam }) =>
      api.getAllPostsByAppVariantAndSelectedGeoAreas1({
        ...requestParameters,
        page: pageParam
      }),
    enabled: isAuthenticated,
    initialPageParam: 0,
    select: useCallback(
      (data: InfiniteData<PagedModelClientPost, number>) =>
        data.pages
          .flatMap((page) => page.content?.map((post) => getPostProps(post)))
          .filter((p) => p !== undefined),
      []
    ),
    getNextPageParam: (lastPage) =>
      (lastPage.page?.totalElements ?? 0) >
      ((lastPage.page?.number ?? 0) + 1) * (lastPage.page?.size ?? 10)
        ? (lastPage.page?.number ?? 0) + 1
        : undefined
  });
};
